<template>
  <img :src="image" @error="altImage" />
</template>

<script>
export default {
  name: "Image",
  props: {
    imageURL: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      defaultImage: require("@/assets/images/default-image.png"),
    };
  },
  computed: {
    image() {
      return this.imageURL === null ? this.defaultImage : this.imageURL;
    },
  },
  methods: {
    altImage(event) {
      event.target.src = this.defaultImage;
    },
  },
};
</script>

<style scoped>
img {
  object-fit: cover;
}
</style>
